<template>
  <div>
    <div class="title">
      <!-- <h1>智慧环保系统监控界面</h1> -->
      <h2>系统已经运行了：{{ formattedDuration() }}</h2>
    </div>
    <div class="container">
      <div class="column">
        <div ref="chart1" style="width: 100%; height: 300px;"></div>
        <p>处理器占用率</p>
      </div>
      <div class="column">
        <div ref="chart2" style="width: 100%; height: 300px;"></div>
        <p>内存空闲率</p>
      </div>
      <div class="column">
        <div ref="chart3" style="width: 100%; height: 300px;"></div>
        <p>磁盘空间使用率</p>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div class="table">
      <table class="your-table-style">
        <thead>
          <tr>
            <th style="width: 10%;">编号</th>
            <th>任务类型</th>
            <th>任务名称</th>
            <th>任务描述</th>
            <th style="width: 10%;">任务状态</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>定时任务</td>
            <td>离线处理</td>
            <td>离线设备处理任务，定时清理离线设备</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['DetectionOfflineDeviceTask'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['DetectionOfflineDeviceTask'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>定时任务</td>
            <td>累计排放</td>
            <td>定时向读取数据计算排放总量</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['DataAggregationLogTask'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['DataAggregationLogTask'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>3</td>
            <td>定时任务</td>
            <td>事件检查</td>
            <td>监测即将过期或已过期的事件</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['TaskExpireEvent'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['TaskExpireEvent'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>4</td>
            <td>定时任务</td>
            <td>站点运行率</td>
            <td>定时判断站点状态累计计算有效率</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['TasksSiteWarnLog'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['TasksSiteWarnLog'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>5</td>
            <td>定时任务</td>
            <td>噪声限值</td>
            <td>定时更新噪声早晚限值变化任务</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['ZaoShengLimitValueTask'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['ZaoShengLimitValueTask'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>6</td>
            <td>定时任务</td>
            <td>活性炭计算</td>
            <td>检查设备状态，确定是否在使用活性炭设备，并计算活性炭剩余以及总去除率。</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['TaskActivatedCharcoal'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['TaskActivatedCharcoal'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>7</td>
            <td>定时任务</td>
            <td>通知事件</td>
            <td>检查通信配置是否符合发送通知的条件</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['NoticeEventTask'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['NoticeEventTask'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>8</td>
            <td>定时任务</td>
            <td>危废事件</td>
            <td>危废相关事件的监测</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['WasteReminderEventTask'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['WasteReminderEventTask'] == 1" alt="运行正常">
            </td>
          </tr>
          <tr>
            <td>9</td>
            <td>定时任务</td>
            <td>报警器任务</td>
            <td>监测报警状态并控制报警器</td>
            <td><img src="@/assets/monitor_err.png" v-if="statusMap['TasksAlarm'] == 0" alt="" title="运行异常">
              <img src="@/assets/monitor_ok.png" v-else-if="statusMap['TasksAlarm'] == 1" alt="运行正常">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import echarts from 'echarts';
import { BaseUrl } from '@/http/config.js'

export default {
  data() {
    return {
      uptimeMilliseconds: 0,
      statusMap: {},
      cpu: 0.0,
      memory: 0.0,
      disk: 0.0,
    };
  },
  mounted() {
    // 第一次加载
    this.fetchUptime();
    // 设置每秒更新一次
    setInterval(() => {
      this.fetchUptime();
    }, 1000 * 60);

    // 第一次加载
    this.fetchStatus();

    // 设置每秒更新一次
    setInterval(() => {
      this.fetchStatus();
    }, 1000 * 60);

    this.getResources();
    // 设置每秒更新一次
    setInterval(() => {
      this.getResources();
    }, 1000 * 5);

  },
  methods: {
    initChart1() {
      const chart = echarts.init(this.$refs.chart1);
      const option = {
        series: [
          {
            type: 'gauge',
            detail: {
              formatter: '{value}%',
              offsetCenter: [0, '70%'], // 调整这里的偏移
            },
            data: [{ value: this.cpu, name: 'CPU' }],
            axisLine: {
              lineStyle: {
                color: [
                  [0.3, '#228b22'],
                  [0.7, '#48b'],
                  [1, '#FF4500'],
                ],
                width: 8,
              },
            },
          },
        ],
      };

      chart.setOption(option);
    },

    initChart2() {
      const chart = echarts.init(this.$refs.chart2);
      const option = {
        series: [
          {
            type: 'gauge',
            detail: {
              formatter: '{value}%',
              offsetCenter: [0, '70%'], // 调整这里的偏移
            },
            data: [{ value: this.memory, name: 'Memory' }],
            axisLine: {
              lineStyle: {
                color: [
                  [0.3, '#FF4500'],
                  [0.7, '#48b'],
                  [1, '#228b22'],
                ],
                width: 8,
              },
            },
          },
        ],
      };

      chart.setOption(option);
    },

    initChart3() {
      const chart = echarts.init(this.$refs.chart3);
      const option = {
        series: [
          {
            type: 'gauge',
            detail: {
              formatter: '{value}%',
              offsetCenter: [0, '70%'], // 调整这里的偏移
            },
            data: [{ value: this.disk, name: 'Disk' }],
            axisLine: {
              lineStyle: {
                color: [
                  [0.3, '#228b22'],
                  [0.7, '#48b'],
                  [1, '#FF4500'],
                ],
                width: 8,
              },
            },
          },
        ],
      };

      chart.setOption(option);
    },
    formattedDuration() {
      const milliseconds = this.uptimeMilliseconds;
      const seconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      return `${days}天 ${hours % 24}小时 ${minutes % 60}分钟`;
    },
    async fetchUptime() {
      try {
        const response = await axios.get(BaseUrl + '/api/system-monitor/uptime');
        this.uptimeMilliseconds = response.data;
      } catch (error) {
        console.error('获取系统运行时间错误:', error);
      }
    },
    async fetchStatus() {
      try {
        const response = await axios.get(BaseUrl + '/api/system-monitor/status');
        if (response.status === 200) {
          this.statusMap = response.data.data;
        }
      } catch (error) {
        console.error('获取状态错误:', error);
      }
    },
    async getResources() {
      try {
        const response = await axios.get(BaseUrl + '/api/system-monitor/resources');
        if (response.status === 200) {
          const obj = response.data;
          this.cpu = obj.cpuUsage;
          this.memory = obj.memoryUsage;
          this.disk = obj.diskUsage;
          this.initChart1();
          this.initChart2();
          this.initChart3();
        }
      } catch (error) {
        console.error('获取状态错误:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 3rem;
}

.title {
  padding: 1rem 0;
}

.container {
  overflow: hidden;
  width: 88%;
  margin: 10px auto;
  /* 清除浮动 */
}

.container p {
  font-size: 1.8rem;
}

.column {
  width: 31%;
  /* 设置列的宽度，根据需要调整 */
  float: left;
  /* 左浮动 */
  margin: 0 1%;
  /* 设置列之间的间距，根据需要调整 */
  box-sizing: border-box;
  /* 盒模型设置为border-box，以免宽度溢出 */
  border: 1px solid #ccc;
  padding: 10px;
  text-align: center;
}

.table {
  width: 86%;
  margin: 10px auto;
  font-size: 1rem;

}

.table img {
  width: 24px;
  height: 24px;
}

.table table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
}

.table table thead {
  font-weight: bolder;
  text-align: center;
}

.table table tbody {
  text-align: center;
}

.table th,
td {
  border: 1px solid #ddd;
  padding: 12px;
}

.table th {
  background-color: #f2f2f2;
}

.table tr:hover {
  background-color: #f5f5f5;
}
</style>